import { render, staticRenderFns } from "./MReasonsReportWidgetAlp.vue?vue&type=template&id=7dff8a04&lang=pug&"
import script from "./MReasonsReportWidgetAlp.vue?vue&type=script&lang=js&"
export * from "./MReasonsReportWidgetAlp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports